import { FieldSelectMulti } from '@/components/looker/field-select-multi';
import { AlertType } from '@/entities/alert-type';

export type AlertTypeFilterProps = {
  value?: AlertType[];
  onChange: (value?: AlertType[]) => void;
};

export function AlertTypeFilter({ value, onChange }: AlertTypeFilterProps) {
  return (
    <FieldSelectMulti
      data-testid="alert-type-filter"
      label="Alert type"
      placeholder="Filter by type"
      options={Object.values(AlertType).map((value) => ({
        value,
        label: alertTypeMap[value],
      }))}
      values={value}
      onChange={(values) =>
        onChange(
          Object.values(AlertType).filter(
            (v) => values?.includes(v.toString()) ?? [],
          ),
        )
      }
    />
  );
}

const alertTypeMap: Record<AlertType, string> = {
  [AlertType.SAFETY]: 'Safety',
  [AlertType.IMBALANCE]: 'SOC Imbalance',
  [AlertType.SOC_OFFSET]: 'SOC Offset',
  [AlertType.PERFORMANCE]: 'Performance',
  [AlertType.INACTIVITY]: 'Inactivity',
  [AlertType.PCS_EFFICIENCY]: 'PCS Efficiency',
  [AlertType.PCS_POWER_AVAILABILITY]: 'PCS Power Availability',
  [AlertType.PCS_POWER_CAPABILITY]: 'PCS Power Capability',
  [AlertType.WARRANTY_CONDITION]: 'Warranty Condition',
  [AlertType.WARRANTY_PENALTY]: 'Warranty Penalty',
  [AlertType.WARRANTY_TAG]: 'Warranty TAG',
  [AlertType.WARRANTY_TAG_PCS]: 'Warranty TAG PCS',
  [AlertType.WARRANTY_RTE]: 'Warranty RTE',
  [AlertType.WARRANTY_SOH]: 'Warranty SOH',
  [AlertType.NO_FINDING]: 'No Finding',
};
